import { requestSystemDownloadScannedInvoice } from 'utils/http/api/system/success-invoices';
import useModal from 'utils/modal/useModal';

export function useSystemFinancingDetailInvoiceInformationLogics(invoiceId: number) {
  const modal = useModal();

  // invoice file 다운로드 호출
  const onClickDownloadInvoiceFile = async (e: any) => {
    e.preventDefault();
    try {
      await requestSystemDownloadScannedInvoice(invoiceId);
    } catch (e) {
      modal.show(e);
    }
  };

  return {
    onClickDownloadInvoiceFile,
  };
}
